import type { FC } from 'react';

import type { IconProps } from './types';

const Search: FC<IconProps> = ({ color = 'currentColor', size = 24, ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size} fill="none" {...props}>
      <path
        d="M18 11C18 7.134 14.866 4 11 4C7.134 4 4 7.134 4 11C4 14.866 7.134 18 11 18C14.866 18 18 14.866 18 11ZM20 11C20 13.125 19.2618 15.0766 18.0303 16.6162L21.707 20.293C22.0976 20.6835 22.0976 21.3165 21.707 21.707C21.3165 22.0976 20.6835 22.0976 20.293 21.707L16.6162 18.0303C15.0766 19.2618 13.125 20 11 20C6.02944 20 2 15.9706 2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11Z"
        fill={color}
      />
    </svg>
  );
};

export default Search;
